import { ClutchWidget } from './Clutch'

export default ClutchWidget
